import React, {Fragment, useEffect, useReducer, useState} from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import $ from "jquery";
import {withRouter} from "react-router-dom";

import CircularProgress from '@mui/material/CircularProgress';

import ImageCanvasCommonNew from "../visComponents/imageCanvasCommonNew";
import {
  setLookActiveCategory,
  setLookContextMenu,
  setLookDemoPointsClicked,
  setLookOpened, setLookPageOpened
} from "../../actions/lookFunctions";
import {getCurrentLayout} from "../appLayout";
import LookZoomer from "./lookZoomer";
import LookContextMenu from "./lookNavigation/lookContextMenu";
// import LookDemoPoints from "./demoPoints/lookDemoPoints";
import {checkForContextMenuCommon, zoomCanvasOut} from "./lookNavigation/lookFunctions";
// import WithDemoShow from "./hocs/withDemoShow";
import COLOR_THEMES, {COLORS} from "../../colorThemes";
import LoadingBar from '../../lib/react-redux-loading-bar';
import {setCanvasScale} from "../../actions/actionFunctions";
import {LOOK_INTRO_STEPS_MOBILE, LOOK_OVERLAYS} from "./core/constants";
import {IS_PRODUCT_JOURNEY} from "../../config";
// import LookCanvasMetadataTest from "./lookCanvasMetadataTest";
import {setGroheSameColorSectionOpened} from "../../actions/groheFunctions";
import Analytics, {LOOK_JOURNEY_ANALYTIC_EVENTS, PRODUCT_JOURNEY_ANALYTIC_EVENTS} from "../../analytics";
import {getFilteredLayersForActiveWizard} from "./lookNavigation/lookMain/lookWizard/lookWizardFunctions";
import {getLookIdUrl, getWizardWithFirstStepCurrentPartId} from "./lookNavigation/lookFunctions2";
import {ROUTES} from "../../routes";
import {setWizardActiveItem} from "../../actions/wizardFunctions";

const LookCanvas = (props) => {

  const {canvasDimensions, canvasId, imageCanvas, isMobile, setLookContextMenu, zoomToFeatureGroup, setLookOpened,
    setLookActiveCategory, activeTheme, visualizersLoaded, lookOpened, setCanvasScale, history, groheSameColorSectionOpened,
    setGroheSameColorSectionOpened, setLookDemoPointsClicked, lookPageOpened, setLookPageOpened, contextMenu,
    lookOverlayOpened, introStep, introHidden, wizardActiveItem, wizardSelectedValues, fabricatorData, wizardList,
    setWizardActiveItem, shopPageOpened} = props;

  const [, forceUpdate] = useReducer(x => x + 1, 0);
  const [showCanvasLoader, setShowCanvasLoader] = useState(false);

  useEffect(() => {
    $("html, body").animate({scrollTop: document.body.scrollHeight}, 1000);
  }, [])

  if (shopPageOpened && lookPageOpened) { // prevent blurry canvas image to be visible on cart open
    return null
  }

  const layout = getCurrentLayout();
  const showPlaceHolders = document.bvConfig ? document.bvConfig.showPlaceholders : false;

  let layers = layout.getLayers(showPlaceHolders);
  if (wizardActiveItem && wizardActiveItem.hideItems) {
    layers = getFilteredLayersForActiveWizard(wizardActiveItem, wizardSelectedValues, layers)
  }

  const layoutType = layout.getCurrentLayoutName();

  const updateLookCanvas = () => {
    forceUpdate(1)
  }

  const checkForContextMenu = (hoveredLayer, event) => {
    if (contextMenu.opened) {
      setLookContextMenu({
        opened: false
      })
      return true
    }
    if (!hoveredLayer) {
      return false
    }
    const {showButtons} = checkForContextMenuCommon(hoveredLayer.partId, hoveredLayer.layerPosition, fabricatorData);
    if ((showButtons.length > 1) && !(hoveredLayer.partId && hoveredLayer.partId === "vanity_legs")) {
      // if (imageCanvas.current && imageCanvas.current.setHoveredLayer) {
      //   imageCanvas.current.renderGreenLayerByZindex(hoveredLayer.zIndex);
      // }
      const analyticsLabel = IS_PRODUCT_JOURNEY
        ? PRODUCT_JOURNEY_ANALYTIC_EVENTS.productCanvasContextMenu + hoveredLayer.partId
        : LOOK_JOURNEY_ANALYTIC_EVENTS.lookCanvasContextMenu + hoveredLayer.partId
      Analytics.sendClickEvent(analyticsLabel);
      setLookContextMenu({
        opened: true,
        partId: hoveredLayer.partId,
        layerPosition: hoveredLayer.layerPosition, // if needed
        position: {
          x: event.clientX,
          y: event.clientY,
        }
      });
      setLookDemoPointsClicked(true);
      return true
    } else if (showButtons.length === 1 && showButtons[0].partId.includes("_wizard")) {
      const wizardId = showButtons[0].partId.split("-")[1];
      setLookOpened(true);
      setWizardActiveItem(wizardList.find(wizardItem => wizardItem.id === wizardId));

      history.push(`${getLookIdUrl(false) + ROUTES.wizard}/${wizardId}`);
      return true
    } else {
      const shouldOpenWizardItem = getWizardWithFirstStepCurrentPartId(wizardList, hoveredLayer.partId);
      if (shouldOpenWizardItem) {
        setLookOpened(true);
        setWizardActiveItem(shouldOpenWizardItem);
        history.push(`${getLookIdUrl(false) + ROUTES.wizard}/${shouldOpenWizardItem.id}`);
        return true
      }
    }
    return false
  }

  const lookCanvasClick = (event) => {

    if (imageCanvas && imageCanvas.current && imageCanvas.current.pinchZoom) {
      // document.querySelector('.canvas-text').innerHTML = 'look click first';
      if (imageCanvas.current.pinchZoom.hasInteraction || window.touchMove) {
        // document.querySelector('.canvas-text').innerHTML = 'look click 22' + imageCanvas.current.pinchZoom.hasInteraction + " " + window.touchMove;
        return false;
      }
      const scale = imageCanvas.current.pinchZoom.getScale();
      if (scale !== 1 || lookOpened || (IS_PRODUCT_JOURNEY && (groheSameColorSectionOpened || lookPageOpened))) {
        setLookOpened(false);
        setLookActiveCategory("");
        if (IS_PRODUCT_JOURNEY) {
          if (groheSameColorSectionOpened) {
            setGroheSameColorSectionOpened(false);
          }
          if (lookPageOpened) {
            setLookPageOpened("");
          }
        }
        zoomCanvasOut(imageCanvas, setCanvasScale);
        history.push("/");
        return false;
      }
    }

    if (isMobile && imageCanvas.current && imageCanvas.current.setHoveredLayer) {
      imageCanvas.current.setHoveredLayer(event);
    }

    if (checkForContextMenu(document.hoveredLayer, event)) {
      return false
    }

    if (document.hoveredLayer) {
      const hoveredPartId = document.hoveredLayer.partId;
      const analyticsLabel = IS_PRODUCT_JOURNEY
        ? PRODUCT_JOURNEY_ANALYTIC_EVENTS.productCanvasLayer + hoveredPartId
        : LOOK_JOURNEY_ANALYTIC_EVENTS.lookCanvasLayer + hoveredPartId
      Analytics.sendClickEvent(analyticsLabel);
      zoomToFeatureGroup(hoveredPartId, null, null, true, !(!IS_PRODUCT_JOURNEY && isMobile));
    }
  };

  const color = visualizersLoaded.length ? COLORS.white : COLOR_THEMES[activeTheme].active;
  const movedCanvasForIntro = isMobile && !introHidden && (lookOverlayOpened === LOOK_OVERLAYS.intro)
    && (introStep <= LOOK_INTRO_STEPS_MOBILE.saveAndMore);

  // console.log("layers", layers);

  return (
    <Fragment>
      <div className={"look-canvas" + (movedCanvasForIntro ? " look-canvas--mobile-intro" : "")}>
        {visualizersLoaded.length ? ( // this added because it loads faster than the canvas dimensions are set
          <ImageCanvasCommonNew layers={layers}
                                canvasId={canvasId}
                                ref={imageCanvas}
                                lookCanvasClick={lookCanvasClick}
                                updateLookCanvas={updateLookCanvas}
                                layoutType={layoutType}
                                layout={layout}
                                layoutScene={layout.scene}
                                width={canvasDimensions.width}
                                height={canvasDimensions.height}
                                useMouseHovering={true}
                                useTouchZoom={true}
                                setShowCanvasLoader={setShowCanvasLoader}
                                fabricatorData={fabricatorData}
          />
        ) : null}
      </div>
      {imageCanvas ? <LookContextMenu imageCanvas={imageCanvas}/> : null}
      {/*{imageCanvas && imageCanvas.current ? (*/}
      {/*  <WithDemoShow>*/}
      {/*    {(showPoints) => <LookDemoPoints imageCanvas={imageCanvas} showPoints={showPoints}/>}*/}
      {/*  </WithDemoShow>*/}
      {/*) : null}*/}
      {imageCanvas && imageCanvas.current && !IS_PRODUCT_JOURNEY ? <LookZoomer imageCanvasRef={imageCanvas.current}/> : null}
      {showCanvasLoader ? (
        <div style={{'color': color}} className={"loader loader--fixed loader--simple" + (lookOpened ? " loader--with-menu" : "")}>
          <LoadingBar className="loader-counter"/>
          <CircularProgress style={{'color': color}}/>
        </div>
      ) : null}
      {/*<LookCanvasMetadataTest/>*/}
    </Fragment>
  )
};

LookCanvas.propTypes = {
  zoomToFeatureGroup: PropTypes.func,
  imageCanvas: PropTypes.object,
}

const mapStateToProps = (store) => {
  const {canvasId, canvasDimensions, canvasCount} = store.bathroomVisualizerState;
  const {contextMenu, lookOpened, lookPageOpened, lookOverlayOpened, introStep, introHidden} = store.lookState;
  const {isMobile, isTouch, activeTheme, visualizersLoaded} = store.serverState;
  const {groheSameColorSectionOpened} = store.groheState;
  const {wizardActiveItem, wizardSelectedValues, wizardList} = store.wizardState;
  const fabricatorData = store.fabricatorState;
  const {activePreset} = store.bathroomVisualizerState;
  const {shopPageOpened} = store.shopState;

  return {
    canvasId,
    canvasDimensions,
    // lookOpened,
    canvasCount,
    isMobile: isMobile || isTouch,
    contextMenu,
    activeTheme,
    visualizersLoaded,
    lookOpened,
    // lookActiveFeature,
    // lookActiveCategory,
    groheSameColorSectionOpened,
    lookPageOpened,
    lookOverlayOpened,
    introStep,
    introHidden,
    wizardActiveItem,
    wizardSelectedValues,
    fabricatorData,
    wizardList,
    activePreset,
    shopPageOpened,
  };
};

const mapDispatchToProps = {
  setLookContextMenu,
  setLookOpened,
  setLookActiveCategory,
  setCanvasScale,
  setGroheSameColorSectionOpened,
  setLookDemoPointsClicked,
  setLookPageOpened,
  setWizardActiveItem,
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(LookCanvas)
)
